var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-uploads-page",on:{"scroll":_vm.onScroll}},[_c('h1',[_vm._v("Upload Media")])])}
var staticRenderFns = []

export { render, staticRenderFns }